import { FrameWorkGetPrimaryColorButton, } from 'orden_express/frameWork/frameWork.js';
import { setFilterTextSearchProduct, setFilterTypeCategory } from 'orden_express/products/productsActions.js';
import { requestGetProductCategory, requestGetProductsFilter } from 'orden_express/products/productsEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, Col, FormGroup, Input, Row, Button } from 'reactstrap';
import { bindActionCreators } from 'redux';


class ProductsFilter extends React.Component {

  getIncialState = () => {
    return {
      navBarIsOpen: false,
      drowpDownTypeUser: false,
      dropDownActiveUser: false,
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getIncialState();
  }

  componentDidMount() {
    this.props.requestGetProductCategory();
  }

  componentDidUpdate(prevProps) {

  }

  drowpDownTypeCategoryToggle = (e) => {
    this.setState({
      drowpDownTypeUserOpen: !this.state.drowpDownTypeUserOpen
    });
  }

  nameOfFieldTypeCategoryFilter = (pValue) => {
    if (pValue === null || pValue === undefined) {
      return 'Todos'
    }
    if (pValue.label) {
      return pValue.label;
    }
    return 'Todos';
  }

  nameOfFieldTextSearchCategoryFilter = (pValue) => {
    if (pValue) {
      return pValue;
    }
    return '';
  }

  applyFilters = () => {
    this.props.parent.applyFilters();
  }
  render() {
    const localProps = this.props;
    return (
      <Card className='mt-1 mb-1 '>
        <CardBody className='pb-0'>
          <Row className='framework-v-center'>
            <Col xs='auto'>
              <b>Filtros</b>
            </Col>
            <Col xs='auto'>
              <Button
                className='btn-icon btn-round mt-0 mb-0'
                color={FrameWorkGetPrimaryColorButton()}
                type='button'
                outline
                size='xs'

                onClick={value => {
                  localProps.setFilterTextSearchProduct('');
                }}
              >
                <i className='fa fa-trash' />
              </Button>
            </Col>
            <Col className=''>
              <FormGroup>
                <Input
                  type='text'
                  placeholder='Buscar'
                  id='idfilterTextSearchProduct'
                  //defaultValue={this.props.productsReducerState.filterTextSearchProduct}
                  value={this.props.productsReducerState.filterTextSearchProduct}
                  onKeyDown={event => {
                    if (event.keyCode === 13) {
                      this.applyFilters();
                    }
                  }}
                  onChange={(newtext) => { localProps.setFilterTextSearchProduct(newtext.target.value) }}
                />
              </FormGroup>
            </Col>
            {/*
            <Col xs='auto' className='pl-0 ml-1'>
              <FormGroup >
                <Button
                  className='btn-icon'
                  color={FrameWorkGetPrimaryColorButton()}
                  id='doSearch'
                  size='xs'
                  type='button'
                  onClick={value => {
                    this.applyFilters();
                  }}
                >
                  <i className='icon-big nc-icon nc-zoom-split'
                  />
                </Button>{' '}
                <UncontrolledTooltip
                  delay={0}
                  target='doSearch'
                >
                  Buscar productos
                  </UncontrolledTooltip>
              </FormGroup>
                </Col>*/}
          </Row>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  return {
    productsReducerState: state.productsReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setFilterTypeCategory: filterTypeCategory => dispatch(setFilterTypeCategory(filterTypeCategory)),
    setFilterTextSearchProduct: filterTextSearchProduct => dispatch(setFilterTextSearchProduct(filterTextSearchProduct)),
    requestGetProductCategory: () => bindActionCreators(dispatch(requestGetProductCategory()), dispatch),
    requestGetProductsFilter: (getFilterProducts) => bindActionCreators(dispatch(requestGetProductsFilter(getFilterProducts))),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsFilter);